import { Injectable } from "@angular/core";
import { Entente, EntentePrealable, NatureAssurance, Ordonnance } from "@jack-sparrow-libraries/emotion-models";
import { EntenteDialogWebAyComponent } from "@featuresAY/ordonnance-web-ay/modals/entente-dialog-web-ay/entente-dialog-web-ay.component";
import { ConfigUtils } from "src/app-ay/core/utils/config.utils";
import { AuthService, EntenteDialogInterfaceService, OrdonnanceHelperService } from "features";
import { UIKitDialogConfig, UiKitDialogService } from "@jack-sparrow-libraries/ui-kit";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class EntenteDialogService implements EntenteDialogInterfaceService {
	constructor(
		private ordonnanceHelper: OrdonnanceHelperService,
		private authService: AuthService,
		private dialog: UiKitDialogService,
	) {}

	async gestionEntente(ordo: Ordonnance, force: boolean = false): Promise<Entente> {
		let entente: Entente = null;
		const client = this.authService.getCurrentConfig();
		const isCnda = ConfigUtils.isCnda(client);

		if (
			!force &&
			(ordo.entente === null ||
				(ordo.entente.codeEntente === EntentePrealable.ACTE_NON_SOUMIS &&
					ordo.contexteFacturation.natureAssurance !== NatureAssurance.SOINS_GRATUIT)) &&
			!isCnda &&
			!this.nessaireEntente(ordo)
		) {
			return Promise.resolve(null);
		}

		const dialogConfig: UIKitDialogConfig = {
			closeButton: false,
			inputs: {
				data: {
					entente: ordo.entente,
					smg: ordo.contexteFacturation.natureAssurance === NatureAssurance.SOINS_GRATUIT,
					datePremierSoins: this.ordonnanceHelper.getOrdonnanceDatePremiereSeance(ordo),
					ordonnanceSoins: ordo.traitements,
					ordonnance: ordo,
				},
			} as any,
			radius: "lg",
			noPadding: true,
		};

		const modalRef = this.dialog.openDialog(EntenteDialogWebAyComponent, dialogConfig);

		const data = await firstValueFrom(modalRef.afterClosed());
		if (data?.entente) {
			entente = data.entente;
		} else {
			entente = null;
		}

		return entente;
	}

	nessaireEntente(ordo: Ordonnance): boolean {
		for (const traitement of ordo.traitements) {
			for (const actes of traitement.traitementActes) {
				if (actes.code === "AIS") {
					return true;
				}
				if (actes.code === "AMI" && (actes.ngapCoefficient === 120 || actes.ngapCoefficient === 500)) {
					return true;
				}
			}
		}
		return false;
	}
}
